// Facebook, Instagram and Messenger open links in their own WebView, as does any Android app WebView ("; wv)").
// Google blocks sign-in there (disallowed_useragent), so its button does nothing: lead with email instead.
const IN_APP = /\b(?:FBAN|FBAV|FB_IAB|FB4A|FBIOS|Instagram|Messenger)\b|; wv\)/i;

export function inAppBrowser(ua = typeof navigator === 'undefined' ? '' : navigator.userAgent): boolean {
  return IN_APP.test(ua);
}

export function isAndroid(ua = typeof navigator === 'undefined' ? '' : navigator.userAgent): boolean {
  return /\bAndroid\b/i.test(ua);
}

/** Opens `href` in Chrome on Android. A browser that can't follow intent:// stays on `href`. */
export function chromeIntent(href: string): string {
  const url = new URL(href);
  return (
    `intent://${url.host}${url.pathname}${url.search}#Intent;scheme=https;package=com.android.chrome;` +
    `S.browser_fallback_url=${encodeURIComponent(url.href)};end`
  );
}
